<div style="overflow: hidden">
  <app-spinner *ngIf="showSpinner"></app-spinner>
  <div #designer></div>
</div>
